/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 12/24/2019
 *
 */

import React from 'react';

/**
 * functional component for TextAreaField
 * @param name
 * @param placeholder
 * @param required
 * @param handleChange
 * @constructor
 */
const TextAreaField = ({labelName, inputName, placeholder, required, value, handleChange, isDisabled}) => {
    return(
        <div>
            <label>
                {labelName}
            </label>
            <textarea
                style={{minWidth: '100%'}}
                name={inputName}
                required={required}
                autoComplete="off"
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                aria-label={inputName}
                disabled={isDisabled}
            />
        </div>
    )
};

export default TextAreaField;
